export default __webpack_public_path__ + "static/media/bg_distribution.3ae1c058f9af958f3baf07c46705ce01.svg";